import type { TPeriodicidadePagamentoEnum } from '@/types/simulacao'
import type { TGrupoParcelas } from '@/utils/calculadora-valores-totais/processador-valores-decimal'
import { extractDateOnly } from '@/utils/date.utils'

type GrupoMensaisApi = { parcelas: TGrupoParcelas }

type GrupoIntermediariasApi = {
  periodicidade: TPeriodicidadePagamentoEnum
  parcelas: TGrupoParcelas
}

export const transformEntradasFromApi = (entradas: TGrupoParcelas) => {
  return entradas.map((parcela) => ({
    data: extractDateOnly(parcela.data),
    valor: parcela.valor,
  }))
}

export const transformGrupoMensaisFromApi = (grupo: GrupoMensaisApi) => {
  if (!grupo.parcelas || grupo.parcelas.length === 0) {
    return { valor: 0, quantidade: 0, dataInicio: null, dataFim: null }
  }

  const parcelasOrdenadas = [...grupo.parcelas].sort((a, b) => a.data!.localeCompare(b.data!))
  const primeira = parcelasOrdenadas[0]!
  const ultima = parcelasOrdenadas.at(-1)!

  return {
    valor: primeira.valor,
    quantidade: grupo.parcelas.length,
    dataInicio: extractDateOnly(primeira.data),
    dataFim: extractDateOnly(ultima.data),
  }
}

export const transformMensaisFromApi = (mensais: GrupoMensaisApi[]) => {
  return mensais.map(transformGrupoMensaisFromApi)
}

export const transformGrupoIntermediariasFromApi = (grupo: GrupoIntermediariasApi) => ({
  valor: grupo.parcelas[0]?.valor ?? 0,
  periodicidade: grupo.periodicidade,
  parcelas: grupo.parcelas.map((parcela) => ({
    data: extractDateOnly(parcela.data),
    valor: parcela.valor,
  })),
})

export const transformIntermediariasFromApi = (intermediarias: GrupoIntermediariasApi[]) => {
  return intermediarias.map(transformGrupoIntermediariasFromApi)
}

export const transformPosConclusaoFromApi = (posConclusao: TGrupoParcelas | null | undefined) => {
  if (!posConclusao || posConclusao.length === 0) return undefined

  const parcelasOrdenadas = [...posConclusao].sort((a, b) => a.data!.localeCompare(b.data!))
  const primeira = parcelasOrdenadas[0]!
  const ultima = parcelasOrdenadas.at(-1)!

  return {
    valor: primeira.valor,
    quantidade: posConclusao.length,
    dataInicio: extractDateOnly(primeira.data),
    dataFim: extractDateOnly(ultima.data),
  }
}
